<template>
    <form @submit="persistSection">

      <fieldset class="form-group">
        <legend>Titre de travail</legend>
        <label class="sr-only" for="title">Titre de travail</label>
        <input type="text" id="title" class="form-control" v-model="sectionDatas.title.datas">
      </fieldset>

      <fieldset class="form-group">
        <legend>Format</legend>
        <label class="sr-only" for="format">Format</label>
        <select id="format" class="form-control" v-model="sectionDatas.format.datas">
          <option v-for="format in availableFormats" v-bind:value="{ id: format.id, name: format.name }">
            {{format.name}}
          </option>
        </select>
      </fieldset>

      <fieldset class="form-group">
        <legend>Rubrique</legend>
        <label class="sr-only" for="rubrique">Rubrique</label>
        <select id="rubrique" class="form-control" v-model="sectionDatas.rubrique.datas">
          <option v-for="rubrique in availableRubriques" v-bind:value="{ id: rubrique.id, name: rubrique.name }">
            {{rubrique.name}}
          </option>
        </select>
      </fieldset>

      <fieldset class="form-group">
        <legend>Résumé</legend>
        <label class="sr-only" for="resume">Résumé</label>
        <textarea id="resume" class="form-control" v-model="sectionDatas.resume.datas"></textarea>
      </fieldset>

      <fieldset class="form-group">
        <legend>Titre Agenda</legend>
        <label class="sr-only" for="titre-agenda">Titre Agenda</label>
        <input type="text" id="titre-agenda" class="form-control" placeholder=""
               v-model="sectionDatas.titreAgenda.datas">
        <b-form-checkbox class="mb-2 mt-4"
                         value="true"
                         unchecked-value="false" v-model="sectionDatas.ajouterALAgenda.datas">
          Ajouter à l'agenda
        </b-form-checkbox>
      </fieldset>

      <fieldset class="form-group">
        <legend>Validité / Dates de l'évèment</legend>
        <i>si date unique ne renseigner que la date de début</i>
        <div class="row">
          <div class="col-sm-6">
            <label class="sr-only" for="validite-addon1">Début</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="validite-addon1">Début</span>
              </div>
              <Datepicker aria-label="début" aria-describedby="validite-addon1"
                          id="validite-start" class="form-control" v-model="sectionDatas.validiteStart.datas"
                          :clear-button="true"></Datepicker>
            </div>
          </div>
          <div class="col-sm-6">
            <label class="sr-only" for="validite-addon2">Début</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="validite-addon2">Fin</span>
              </div>
              <Datepicker aria-label="début" aria-describedby="validite-addon2"
                          id="validite-fin" class="form-control" v-model="sectionDatas.validiteEnd.datas"
                          :clear-button="true"></Datepicker>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="form-group">
        <legend>Lieu</legend>
        <label class="sr-only" for="lieu">Lieu</label>
        <input type="text" id="lieu" class="form-control" v-model="sectionDatas.lieu.datas"
               placeholder="uniquement le nom">
      </fieldset>

      <fieldset class="form-group">
        <legend>Adresse</legend>
        <label class="sr-only" for="adresse">Adresse</label>
        <input type="text" id="adresse" class="form-control" placeholder="adresse du lieu de l'évènement"
               v-model="sectionDatas.adresse.datas">
      </fieldset>

      <fieldset class="form-group">
        <legend>Lien externe</legend>
        <label class="sr-only" for="lien-externe">Lien externe</label>
        <input type="text" id="lien-externe" class="form-control"
               placeholder="Lien externe pour l'évènement (décadanse, site de l'évènement, event facebook..)"
               v-model="sectionDatas.lienExterne.datas">
      </fieldset>

      <fieldset class="form-group">
        <legend>Descriptif Agenda</legend>
        <label class="sr-only" for="descriptif-agenda">Descriptif Agenda</label>
        <textarea id="descriptif-agenda" class="form-control" v-model="sectionDatas.descriptifAgenda.datas"></textarea>
      </fieldset>

      <button type="submit" class="btn btn-primary" v-bind:disabled="editPending">Valider cette étape</button>

    </form>
</template>

<script>

  import bdd from '../../api/bdd'
  import Datepicker from 'vuejs-datepicker'

  export default {

    name: 'ResumeForm',

    components: {
      Datepicker
    },

    props: {
      subject: {},
      editPending: false
    },

    data() {
      return {
        sectionName: 'resume',
        sectionDatas: {
          title: {
            name: 'titre de travail',
            datas: ''
          },
          resume: {
            name: 'resume',
            datas: ''
          },
          titreAgenda: {
            name: 'titre agenda',
            datas: ''
          },
          ajouterALAgenda: {
            name: 'ajouter à l\'agenda',
            datas: ''
          },
          lieu: {
            name: 'lieu',
            datas: ''
          },
          adresse: {
            name: 'adresse',
            datas: ''
          },
          lienExterne: {
            name: 'lien externe',
            datas: ''
          },
          descriptifAgenda: {
            name: 'descriptif agenda',
            datas: ''
          },
          format: {
            name: 'format',
            datas: {
              id: null,
              name: ''
            }
          },
          rubrique: {
            name: 'rubrique',
            datas: {
              id: null,
              name: ''
            }
          },
          validiteStart: {
            name: 'validiteStart',
            datas: null
          },
          validiteEnd: {
            name: 'validiteEnd',
            datas: null
          }
        },
        availableFormats: [],
        availableRubriques: [],
        rubriqueId: '',
        formatId: ''
      }
    },

    mounted: function () {
      this.sectionDatas.title.datas = this.subject.title
      this.sectionDatas.resume.datas = this.subject.resume
      this.sectionDatas.lieu.datas = this.subject.lieu
      this.sectionDatas.validiteStart.datas = this.subject.validiteStart
      this.sectionDatas.validiteEnd.datas = this.subject.validiteEnd
      this.sectionDatas.adresse.datas = this.subject.adresse
      this.sectionDatas.ajouterALAgenda.datas = this.subject.ajouterALAgenda
      this.sectionDatas.lienExterne.datas = this.subject.lienExterne
      this.sectionDatas.descriptifAgenda.datas = this.subject.descriptifAgenda
      this.sectionDatas.titreAgenda.datas = this.subject.titreAgenda
      // on récupère les formats disponibles
      bdd.getAvailableLabel('formats')
        .then(formats => {
          this.availableFormats = formats
          this.availableFormats.sort((a, b) => (a.name.localeCompare(b.name)))
          console.log('formats disponibles : ', this.availableFormats)
          // puis les rubriques disponbibles
          bdd.getAvailableLabel('rubriques')
            .then(rubriques => {
              this.availableRubriques = rubriques
              this.availableRubriques.sort((a, b) => (a.name.localeCompare(b.name)))
              console.log('rubriques disponibles : ', this.availableRubriques)
              // une fois qu'on connait tous les labels à ajouter (pour rubriques et formats)
              // on met à jour les labels sur le board Trello
              this.$emit('update-labels', this.availableRubriques.concat(this.availableFormats))
              // on met alors à jour le format et rubrique actuelle
              if (this.subject.rubrique !== null) {
                this.setRubrique()
              }
              if (this.subject.format !== null) {
                this.setFormat()
              }
            })
            .catch(e => {
              console.log(e)
            })
        })
      this.$emit('push-section', this.sectionDatas, this.sectionName)
    },

    methods: {
      persistSection: function (e) {
        e.preventDefault()
        this.$emit('push-edit', this.sectionDatas, this.sectionName)
      },
      setRubrique: function () {
        // on met à jour notre rubrique actuelle
        // on prépare notre ID de rubrique pour la comparaison (car on la veux sans le préfixe de l'API
        let index = this.subject.rubrique.lastIndexOf('/') + 1
        let rubriqueCleanId = this.subject.rubrique.substr(index)
        for (let i = 0; i < this.availableRubriques.length; i++) {
          if (rubriqueCleanId === this.availableRubriques[i].id) {
            this.sectionDatas.rubrique.datas.id = this.availableRubriques[i].id
            this.sectionDatas.rubrique.datas.name = this.availableRubriques[i].name
          }
        }
      },
      setFormat: function () {
        // et on met à jour notre format actuel
        for (let i = 0; i < this.availableFormats.length; i++) {
          // TODO pour l'instant comparaison un peu bancale car les id ne sont pas dans le mm format..
          if (parseInt(this.subject.format.replace(/\D/g, '')) === this.availableFormats[i].id) {
            this.sectionDatas.format.datas.id = this.availableFormats[i].id
            this.sectionDatas.format.datas.name = this.availableFormats[i].name
          }
        }
      }
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/EditSub/ResumeForm.vue